// extracted by mini-css-extract-plugin
export default {"button":"Button_button__9lO54","disabled":"Button_disabled__VcxMN"};